import { createVuetify } from "vuetify";

import * as directives from "vuetify/directives";
import "vuetify/styles";

export default createVuetify({
  directives,
});
